export default {"src":"/_next/static/media/nubel_isologo.88b73e5f.svg","height":61,"width":60,"blurWidth":0,"blurHeight":0};